import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';
import SlashIcon from 'svgs/SlashIcon';

const createBreadcrumbs = ({ palette }: Theme): Components => ({
  MuiBreadcrumbs: {
    defaultProps: {
      separator: <SlashIcon sx={{ fontSize: '1em' }} />,
    },
    styleOverrides: {
      root: {
        lineHeight: 1.0666666666666667,
      },
      separator: {
        marginLeft: 0,
        marginRight: 0,
        // TODO: Put a different color according to the parent color
        color: palette.primary.stroke,
        fontSize: '20px',
      },
    },
  },
});

export default createBreadcrumbs;
